import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import RichardsonHeroSection from "./components/HeroSection";
import RichardsonStickyNav from "./components/StickyNav";
import RichardsonProcessingTimeSection from "./components/ProcessingTimeSection";
import RichardsonServicesSection from "./components/ServicesSection";
import RichardsonLocalAreaSection from "./components/LocalAreaSection";
import RichardsonTravelTimingSection from "./components/TravelTimingSection";
import RichardsonDestinationsSection from "./components/DestinationsSection";
import RichardsonTestimonialsSection from "./components/TestimonialsSection";
import RichardsonAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import RichardsonComparisonSection from "./components/ComparisonSection";
import RichardsonMistakesSection from "./components/MistakesSection";
import RichardsonHowItWorksSection from "./components/HowItWorksSection";
import RichardsonFAQSection, { faqs as rawFaqs } from "./components/FAQSection";
import RichardsonHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import RichardsonFinalCTA from "./components/FinalCTA";

const faqs = rawFaqs.map((f: { question: string; answer: string }) => ({ q: f.question, a: f.answer }));

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function RichardsonPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Richardson"
        state="Texas"
        stateAbbr="TX"
        route="/richardson"
        title="Richardson TX Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Emergency and expedited passport services in Richardson, TX — as fast as 24 hours. Telecom Corridor tech professionals, UTD students, and Dallas County families. A+ BBB rated registered State Dept. courier. No office visit required."
        geoPlacename="Richardson, Texas"
        geoPosition="32.9483;-96.7299"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Texas"
        statePageRoute="/states/texas"
      />
      <RichardsonHeroSection />
      <RichardsonStickyNav />
      <RichardsonProcessingTimeSection />
      <RichardsonLocalAreaSection />
      <RichardsonServicesSection />
      <RichardsonTravelTimingSection />
      <RichardsonDestinationsSection />
      <RichardsonTestimonialsSection />
      <RichardsonAcceptanceFacilitiesSection />
      <RichardsonComparisonSection />
      <RichardsonMistakesSection />
      <RichardsonHowItWorksSection />
      <RichardsonFAQSection />
      <RichardsonHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/richardson" state="TX" />
      <RichardsonFinalCTA />
    </div>
  );
}